<p-toast styleClass="custom-toast" />

<router-outlet></router-outlet>
